module.exports = __webpack_public_path__ + "static/img/zgg.7233fd1f.jpg";